import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

import './styles.less';

const { Text } = Typography;

const InputLabel = ({ title, subtitle }) => (
  <div className="input-label">
    <Text className="input-label__title">{title}</Text>
    <br />
    <Text type="secondary">{subtitle}</Text>
  </div>
);

InputLabel.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default InputLabel;
